module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "abstract.3661f2ae.svg";